.accordion {
  border: none;
  border-radius: var(--tuna-shape-borderRadius);
  overflow: hidden;
  margin-bottom: 0;
}

.accordion + .accordion {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion:has(+ .accordion) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
  cursor: pointer;
  list-style: none;
  font-family: var(--tuna-typography-fontFamily);
  font-size: var(--tuna-typography-caption-fontSize, 0.75rem);
  font-weight: 400;
  color: var(--tuna-palette-text-secondary);
  min-height: 32px;
  transition: background-color 150ms;
  user-select: none;
}

.summary::-webkit-details-marker {
  display: none;
}

.summary::marker {
  display: none;
  content: '';
}

.summary:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: -2px;
}

.summary:hover {
  background-color: var(--tuna-palette-action-hover);
}

.summaryContent {
  display: flex;
  align-items: center;
  flex: 1;
  margin: 0;
}

.summaryIcon {
  display: flex;
  align-items: center;
  transition: transform 200ms;
}

.accordion[open] > .summary .summaryIcon {
  transform: rotate(180deg);
}

.details {
  padding: 8px 16px 16px;
}
